import styled from "styled-components";

export const ContainerFileDropzone = styled.div`
    padding: 16px;
    height: 120px;
`

export const ContainerFiles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    border: 1px dashed #68737D;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    color: #2F5BFF;
    font-size: 14px;
    margin-top: 10px;

    opacity: 0;
    transform: scale(0.99);
    animation: fadeIn .28s forwards;

    @keyframes fadeIn {
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

`;

export const ContainerWithFile = styled.div`
    display: flex;
    max-width: 355px;
    gap: 8px;

    padding: 10px 12px;
    border-radius: 4px;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #C2C8CC;
    color: #2F3941;
    font-size: 14px;
    font-weight: 400;

    opacity: 0;
    transform: scale(0.99);
    animation: fadeIn .25s forwards;

    @keyframes fadeIn {
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    &.fade-out {
        opacity: 0;
        transform: scale(0.99);
    }

`